// extracted by mini-css-extract-plugin
export default {"heading":"TileHeading_heading__UNemI"};